/* qx-core :: cart.js */
function qxCartHydrate(count) {
    var badge = document.getElementById('qx-cart-count');
    if (badge) {
        badge.textContent = String(count);
        badge.classList.toggle('is-empty', count === 0);
    }
    qxTrackEvent('qx_cart_state', { items: count });
}
